<div
  class="next-modal next-modal--shown cdk-overlay-dark-backdrop"
  id="raiseNowModal"
  [class.raisenow-modal--tamaro]="isTamaroModalShown"
  [style.visibility]="
    isEPPModalShown || isTamaroModalShown ? 'visible' : 'hidden'
  "
>
  <div class="next-modal__container">
    <div class="next-modal__body">
      <fmnts-modal-title>
        {{ 'raisenow_headline' | translate }}
      </fmnts-modal-title>
      <!-- only one of the specific iframes can be instantiated
      (depending on the payment method) -->
      <next-raisenow-iframe-epp
        (closed)="closeEPPModal()"
        (paymentResult)="onEppModalSuccess($event)"
        [style.display]="isEPPModalShown ? 'block' : 'none'"
      />
      @if (isTamaroModalShown) {
        <next-raisenow-tamaro-iframe
          (closed)="closeTamaroModal()"
          (finished)="showSuccessModalAndResetForm()"
        />
      }
    </div>
  </div>
</div>
